import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetPositionState, getPosition } from "../../../store/position/action";
import { resetPositionChangeState, getPositionChange as onGetPositionChanges, addNewPositionChange as onAddNewPositionChange, updatePositionChange as onUpdatePositionChange, deletePositionChange as onDeletePositionChange, getPositionChangeLoading } from "../../../store/positionChange/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const PositionChange = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, companies, companyLoading, positionChanges, isPositionChangeCreated, isPositionChangeSuccess, loading, error, employees, employeeLoading, positions, positionLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    positionChanges: state.PositionChange.positionChanges,
    isPositionChangeCreated: state.PositionChange.isPositionChangeCreated,
    isPositionChangeSuccess: state.PositionChange.isPositionChangeSuccess,
    loading: state.PositionChange.loading,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    error: state.PositionChange.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
  }));

  const [positionChangeList, setPositionChangeList] = useState([]);
  const [positionChange, setPositionChange] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [positionList, setPositionList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];
  const onClickDelete = (positionChange) => {
    setPositionChange(positionChange);
    setDeleteModal(true);
  };

  const handleDeletePositionChange = () => {
    if (positionChange) {
      dispatch(onDeletePositionChange(positionChange));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(positionChanges)) {
      let filteredPositionChanges = positionChanges;
      if (activeTypeTab !== "all") {
        filteredPositionChanges = positionChanges.filter((positionChange) => positionChange.position_change_status.name === activeTypeTab);
      }
      setPositionChangeList(filteredPositionChanges);
    }
  }, [positionChanges]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredPositionChanges = positionChanges;
      if (type !== "all") {
        filteredPositionChanges = positionChanges.filter((positionChange) => positionChange.position_change_status.name === type);
      }
      setPositionChangeList(filteredPositionChanges);
    }
  };

  useEffect(() => {
    if (companySelected && companySelected.value) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetPositionChangeState());
      dispatch(onGetPositionChanges({ companyId: companySelected?.value ?? "" }));
      handleGetEmployee(userData?.companyId);
      handleGetPosition(userData?.companyId);
    }
  }, [companySelected]);

  const handleGetEmployee = (id) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ companyId: id }));
  };

  const handleGetPosition = (id) => {
    dispatch(resetPositionState());
    dispatch(getPosition({ companyId: id }));
  };

  useEffect(() => {
    if (!isEmpty(positions)) {
      var data = [];
      var opt = [];
      positions.forEach((item, key) => {
        const position_name = item.name;
        const departmentId = item.departmentId;
        const departement_name = item.position_department && item.position_department.name;
        const id = item.id;
        var obj = { label: `${position_name}, ${departement_name}`, value: id, departmentId: departmentId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPositionList(data);
    }
  }, [positions]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    employees.forEach((item, key) => {
      const name = item.name;
      const id = item.userId;
      const position = item?.employee_user?.user_position && item?.employee_user?.user_department ? { label: `${item?.employee_user?.user_position?.name}, ${item?.employee_user?.user_department?.name}`, value: item?.employee_user?.user_position?.id, departmentId: item?.employee_user?.user_department?.id } : "";
      var obj = { label: name, value: id, position: position };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (employees.length > 0) {
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, modal]);

  const handlePositionChangeClick = useCallback(
    (arg) => {
      const data = arg;

      // setPositionList([]);
      // dispatch(resetPositionState());
      // dispatch(getPosition({ companyId: data.position_change_employee.companyId, status: 2 }));

      setPositionChange({
        id: data.id,
        description: data.description,
        startat: data.startat,
        reason: data.reason,
        employee: data.position_change_user && {
          label: data.position_change_user ? data.position_change_user.name : "",
          value: data.position_change_user ? data.position_change_user.id : "",
          position: data.position_change_user.user_position && data.position_change_user?.user_department ? { label: `${data.position_change_user.user_position.name}, ${data.position_change_user?.user_department?.name}`, value: data.position_change_user.user_position.id, departmentId: data.position_change_user?.user_department?.id } : "",
        },
        oldposition: data.position_change_oldposition === null ? "" : { label: `${data.oldPosition_name}, ${data.oldDepartment_name}`, value: data.oldPositionId, departmentId: data.oldDepartmentId },
        position: data.position_change_position === null ? "" : { label: `${data.position_name}, ${data.department_name}`, value: data.positionId, departmentId: data.departmentId },
        company: data.position_change_company && {
          label: data.position_change_company ? data.position_change_company.name : "",
          value: data.position_change_company ? data.position_change_company.id : "",
        },
        client: data.position_change_client && {
          label: data.position_change_client ? data.position_change_client.name : "",
          value: data.position_change_client ? data.position_change_client.id : "",
        },
      });

      setIsEdit(true);
      toggle();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggle, dispatch, userType]
  );

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePositionChange(element.value));
    });
    checkall.checked = false;
  };

  const onClickApprove = (employee) => {
    setPositionChange(employee);
    setApproveModal(true);
  };

  const handleApproveEmployee = () => {
    if (positionChange) {
      positionChange.setApprove = true;
      dispatch(onUpdatePositionChange(positionChange));
      dispatch(resetPositionChangeState());
      dispatch(onGetPositionChanges());
      setApproveModal(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updatePositionChange") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handlePositionChangeClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deletePositionChange") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approvePositionChange") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui perubahan jabatan untuk ${data.position_change_user.name}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Karyawan",
        accessor: "position_change_employee.name",
        filterable: true,
      },
      {
        Header: "Posisi Lama",
        accessor: "oldPosition_name",
        filterable: true,
      },
      {
        Header: "Posisi Baru",
        accessor: "position_name",
        filterable: true,
      },
      {
        Header: "Alasan",
        accessor: "reason",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Tanggal",
        accessor: "startat",
        filterable: true,
        Cell: (brand) => <> {handleValidDate(brand.row.original.startat)} </>,
      },
      {
        Header: "Status",
        accessor: "position_change_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [handlePositionChangeClick, userType, userRole]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: positionChangeList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var reason = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      reason: reason,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetPositionChanges(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setPositionChangeList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetPositionChangeState());
    dispatch(onGetPositionChanges({ companyId: companySelected?.value ?? "" }));
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      description: (positionChange && positionChange.description) ?? "",
      reason: (positionChange && positionChange.reason) ?? "",
      startat: (positionChange && positionChange.startat) ?? "",
      client: (positionChange && positionChange.client) || clientSelected,
      company: (positionChange && positionChange.company) || companySelected,
      employee: (positionChange && positionChange.employee) ?? "",
      rates: (positionChange && positionChange.rates) ?? "",
      position: (positionChange && positionChange.position) ?? "",
      oldposition: (positionChange && positionChange.oldposition) ?? "",
    },
    validationSchema: Yup.object({
      reason: Yup.string().required("Please Enter Reason").nullable(true),
      position: Yup.object().required("Please Pick Position").nullable(true),
      employee: Yup.object().required("Please Pick employee").nullable(true),
      startat: Yup.string().required("Please Pick Effective Date").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getPositionChangeLoading());
      if (isEdit) {
        const updatePositionChange = {
          id: positionChange ? positionChange.id : 0,
          statusId: 1,
          description: values.description,
          reason: values.reason,
          startat: values.startat,
          rates: values.rates,
          employeeId: values.employee.value,
          companyId: values.employee.companyId,
          departmentId: values.position.departmentId,
          name: values.position.name,
          positionId: values.position.positionId,
          position_name: values.position.position_name,
          oldDepartmentId: values.oldposition.departmentId,
          oldDepartment_name: values.oldposition.name,
          oldPositionId: values.oldposition.positionId,
          oldPosition_name: values.oldposition.position_name,
        };
        dispatch(onUpdatePositionChange(updatePositionChange));
        validation.resetForm();
      } else {
        const newPositionChange = {
          statusId: 1,
          description: values.description,
          reason: values.reason,
          startat: values.startat,
          rates: values.rates,
          userId: values.employee.value,
          clientId: values.client.value,
          companyId: values.company.value,
          name: values.position.name,
          positionId: values.position.value,
          position_name: values.position.label ? values.position.label.split(",")[0] : null,
          departmentId: values.position.departmentId,
          department_name: values.position.label ? values.position.label.split(",")[1] : null,
          oldDepartmentId: values.oldposition.departmentId,
          oldDepartment_name: values.oldposition.label ? values.oldposition.label.split(",")[1] : null,
          oldPositionId: values.oldposition.value,
          oldPosition_name: values.oldposition.label ? values.oldposition.label.split(",")[0] : null,
        };
        dispatch(onAddNewPositionChange(newPositionChange));
        validation.resetForm();
      }
      toggle();
    },
  });

  function handleEmployeeClick(e) {
    setPositionList([]);
    dispatch(resetPositionState());
    dispatch(getPosition({ companyId: e.companyId, status: 2 }));
    validation.setFieldValue("oldposition", { label: e.position.position_name + ", " + e.department.name, value: e.position.id, positionId: e.position.id, position_name: e.position.position_name, departmentId: e.department.id, name: e.department.name });
    return false;
  }

  document.title = "Perubahan Jabatan | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={positionChangeList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePositionChange} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={positionChange && positionChange.position_change_employee ? positionChange.position_change_employee.name + " - " + positionChange.position_change_position.position_name : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Karyawan" pageTitle="Perubahan Jabatan" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createPositionChange") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-user-unfollow-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
              <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
            </button>
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deletePositionChange") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Hapus
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="positionChangeList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-user-unfollow-line me-1 align-bottom fs-14"></i> SEMUA PERUBAHAN JABATAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <Select
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                        Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Perubahan Jabatan" : "Tambah Perubahan Jabatan"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="client-field" className="form-label">
                                Grup Usaha&nbsp;{" "}
                                {clientLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="client"
                                value={validation.values.client}
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                placeholder="Pilih Grup Usaha"
                                onChange={(e) => {
                                  validation.setFieldValue("client", e);
                                }}
                                options={clientList}
                              ></Select>
                            </div>

                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="company-field" className="form-label">
                                Perusahaan&nbsp;{" "}
                                {companyLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="company"
                                value={validation.values.company}
                                placeholder="Pilih Perusahaan"
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                onChange={(e) => {
                                  dispatch(setBranchSelect(null));
                                  dispatch(setCompanySelect(e));
                                  validation.setFieldValue("company", e);
                                }}
                                options={companyList}
                              ></Select>
                            </div>

                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="employee-field" className="form-label">
                                Karyawan <span className="text-danger">*</span>&nbsp;
                                {employeeLoading ? (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                ) : (
                                  ""
                                )}
                              </Label>
                              <Select
                                name="employee"
                                value={validation.values.employee}
                                placeholder="Pilih Karyawan"
                                onChange={(e) => {
                                  validation.setFieldValue("oldposition", e.position);
                                  validation.setFieldValue("employee", e);
                                  // handleGetPosition(e.userId);
                                  // handleGetEmployee(e.value);
                                }}
                                options={employeeList}
                              ></Select>
                              {validation.touched.employee && validation.errors.employee ? (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.employee}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="date-field" className="form-label">
                                Tanggal Berlaku
                              </Label>
                              <Flatpickr
                                name="startat"
                                className="form-control"
                                placeholder="Pilih Tanggal"
                                options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                value={validation.values.startat ?? ""}
                                onChange={(o, e) => {
                                  validation.setFieldValue("startat", e);
                                }}
                              />
                              {validation.touched.startat && validation.errors.startat ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.startat}
                                </p>
                              ) : null}
                            </div>
                          </div>
                          <div className="row">
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="oldposition" className="form-label">
                                Posisi Lama{" "}
                              </Label>
                              <Select name="oldposition" isDisabled={true} value={validation.values.oldposition} invalid={validation.touched.oldposition && validation.errors.oldposition ? true : false}></Select>
                              {validation.touched.oldposition && validation.errors.oldposition ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.oldposition}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="position" className="form-label">
                                Posisi Baru{" "}
                                {positionLoading ? (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                ) : (
                                  ""
                                )}{" "}
                              </Label>
                              <Select
                                name="position"
                                value={validation.values.position}
                                placeholder="Isi Jabatan"
                                onChange={(e) => {
                                  validation.setFieldValue("position", e);
                                }}
                                options={positionList}
                                invalid={validation.touched.position && validation.errors.position ? true : false}
                              ></Select>
                              {validation.touched.position && validation.errors.position ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.position}
                                </p>
                              ) : null}
                            </div>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="reason-field" className="form-label">
                              Alasan{" "}
                            </Label>
                            <Input name="reason" id="reason-field" className="form-control" placeholder="Isi Alasan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.reason ?? ""} invalid={validation.touched.reason && validation.errors.reason ? true : false} />
                            {validation.touched.reason && validation.errors.reason ? <FormFeedback type="invalid">{validation.errors.reason}</FormFeedback> : null}
                          </div>
                          <div className="mb-4">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Batal
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="reason">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PositionChange;
